import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { async } from '@angular/core/testing';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { mobiscroll, MbscDatetimeOptions, MbscRangeOptions } from '@mobiscroll/angular';
import Swal from 'sweetalert2';


mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light',


};

const now = new Date();
//const week = [ new Date(now.getFullYear(),0, 1),now];
const week = [ now,now];


@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css'],
  providers: [DatePipe]
})



export class ExportComponent implements OnInit {

  range: Array < Date > = week;
  date: Array < Date > = [];
  nonForm: Array < Date > = [];
  external = week;
  d1:any;
  d2:any;
  status_approved:any = 'ALL';
  domiciliation_product_type: string = 'SEGUROS_MERCANTIL';

  trace_documets:any  =[];

  // 🆕 2026-05-23 — Master-detail: trace seleccionado para el panel derecho
  selectedTrace: any = null;

  selectTrace(item: any) {
    this.selectedTrace = item;
  }

  unselectTrace() {
    this.selectedTrace = null;
  }

  isSelected(item: any): boolean {
    return this.selectedTrace?._id && item?._id && this.selectedTrace._id === item._id;
  }

  // 🆕 2026-05-23 — Drawer de Historial completo (todos los tipos, paginado)
  // ver docs/reportes/REPORT_CARD_REQUIREMENTS.md → "Vista de histórico"
  historyDrawerOpen: boolean = false;
  historyLoading: boolean = false;
  historyItems: any[] = [];
  historyPage: number = 1;
  historyLimit: number = 25;
  historyTotal: number = 0;
  historyTotalPages: number = 0;
  historyLatestCompleteIds: string[] = [];
  historyFilters: any = {
    state: '',
    type: '',
    executed_by: '',
    from: '',
    to: ''
  };

  async openHistoryDrawer() {
    this.historyDrawerOpen = true;
    this.historyPage = 1;
    // 🆕 Pre-popular filtro con el tipo de reporte ACTUALMENTE seleccionado en el form
    // (this._tracePollType es el enum del backend, ej. "FEES_PAYMENTS_REPORT_V3").
    if (this._tracePollType) {
      this.historyFilters.type = this._tracePollType;
    }
    await this.loadHistory();
  }

  // 🆕 2026-05-23 — Solo mostrar "Descargar" en el último COMPLETE de cada tipo
  isLatestComplete(item: any): boolean {
    if (!item?._id) return false;
    return this.historyLatestCompleteIds.includes(String(item._id));
  }

  // 🆕 2026-05-23 — Descargar el histórico completo en XLSX (últimos 50 por tipo)
  exportHistoryXlsx() {
    try {
      const url = this._user.traceHistoryXlsxUrl(50);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Historial_Reportes_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.error('exportHistoryXlsx error:', err);
      window.alert('Error al exportar el histórico');
    }
  }

  closeHistoryDrawer() {
    this.historyDrawerOpen = false;
  }

  async loadHistory() {
    this.historyLoading = true;
    try {
      const params: any = {
        mode: 'history',
        page: String(this.historyPage),
        limit: String(this.historyLimit)
      };
      if (this.historyFilters.state) params.state = this.historyFilters.state;
      if (this.historyFilters.type) params.type = this.historyFilters.type;
      if (this.historyFilters.executed_by) params.executed_by = this.historyFilters.executed_by;
      if (this.historyFilters.from) params.from = this.historyFilters.from;
      if (this.historyFilters.to) params.to = this.historyFilters.to;
      // 🆕 Filtro preservado
      if (this.historyFilterPreserved) params.preserved = this.historyFilterPreserved;

      const result = await this._user.traceDocumentsGet(params);
      this.historyItems = result?.resp || [];
      this.historyTotal = result?.pagination?.total || 0;
      this.historyTotalPages = result?.pagination?.totalPages || 0;
      this.historyLatestCompleteIds = result?.latest_complete_ids || [];
    } catch (err) {
      console.error('loadHistory error:', err);
      this.historyItems = [];
      this.historyLatestCompleteIds = [];
    } finally {
      this.historyLoading = false;
    }
  }

  async applyHistoryFilters() {
    this.historyPage = 1;
    await this.loadHistory();
  }

  async clearHistoryFilters() {
    this.historyFilters = { state: '', type: '', executed_by: '', from: '', to: '' };
    this.historyPage = 1;
    await this.loadHistory();
  }

  async goToHistoryPage(p: number) {
    if (p < 1 || p > this.historyTotalPages) return;
    this.historyPage = p;
    await this.loadHistory();
  }

  // Lista única de tipos del catálogo de friendly names (para el dropdown de filtros)
  getReportTypesForFilter(): { value: string; label: string }[] {
    return Object.entries(this.REPORT_FRIENDLY_NAMES).map(([value, label]) => ({ value, label }));
  }

  // 🆕 2026-05-24 — Procesos en curso: lista global de PENDING para mostrar debajo del form.
  // Se carga via polling cada 5s; click en uno selecciona el tipo en el form.
  activeProcesses: any[] = [];
  private _activePollInterval: any = null;

  async loadActiveProcesses() {
    try {
      // Llamamos al historial con state=PENDING (todos los tipos)
      const result = await this._user.traceDocumentsGet({
        mode: 'history', state: 'PENDING', page: '1', limit: '20'
      });
      this.activeProcesses = result?.resp || [];
    } catch (err) {
      console.error('loadActiveProcesses error:', err);
      this.activeProcesses = [];
    }
  }

  private _startActiveProcessesPolling() {
    if (this._activePollInterval) return;
    this.loadActiveProcesses();
    this._activePollInterval = setInterval(() => this.loadActiveProcesses(), 5000);
    if (this._activePollInterval.unref) this._activePollInterval.unref?.();
  }

  private _stopActiveProcessesPolling() {
    if (this._activePollInterval) {
      clearInterval(this._activePollInterval);
      this._activePollInterval = null;
    }
  }

  // 🆕 2026-05-25 — Detectar si hay un proceso PENDING del MISMO tipo que está
  // seleccionado actualmente en el form. Usado para deshabilitar el botón
  // "Generar Reporte" y dar feedback inmediato al usuario (sin llegar al 409
  // del back). Mapea this.type → enum del backend, luego busca en activeProcesses.
  getInflightForCurrentType(): any | null {
    const value = String(this.type || '');
    const valueToEnum: Record<string, string> = {
      '2': 'INSTALLMENT_1', '3': 'INVOICES_1', '4': 'PAYMETS_S2', '5': 'PAYMETS_S3',
      '6': 'CLIENT_1', '7': 'CLIENT_2', '8': 'SAP_P', '9': 'SAP_G',
      '15': 'DIST_PAYMENTS', '17': 'CLIENT_STADITIC', '18': 'FEES_PAYMENTS_REPORT',
      '19': 'FEES_PAYMENTS_REPORT_V3', '20': 'BIOMETRIC',
      '22': 'PLANS_REPORT', '23': 'BDV_BP_TRANSACTIONS',
      '33': 'REACTIVATION_FEES_STATUS_REPORT', '37': 'CARTERA_HEALTH_360', '43': 'SAP_BP',
      '44': 'SAP_PARTIDAS_ABIERTAS', '45': 'SAP_PERDIDAS_INCOBRABLES'
    };
    const targetEnum = valueToEnum[value];
    if (!targetEnum) return null;
    return (this.activeProcesses || []).find(
      (p: any) => p?.type === targetEnum && p?.state === 'PENDING' && !p?.cancel_requested
    ) || null;
  }

  // Filtro inverso: del enum del backend al value numérico del form
  private _reportTypeToFormValue(reportType: string): string | null {
    // Mapa enum→value derivado de las opciones del HTML
    const map: Record<string, string> = {
      'CLIENT_1': '6', 'INVOICES_1': '3', 'CLIENT_2': '7',
      'INSTALLMENT_1': '2', 'DIST_PAYMENTS': '15', 'PAYMETS_S2': '4', 'PAYMETS_S3': '4',
      'CLIENT_STADITIC': '17', 'FEES_PAYMENTS_REPORT': '18',
      'FEES_PAYMENTS_REPORT_V3': '19', 'FEES_PAYMENTS_REPORT_V2': '19',
      'REACTIVATION_FEES_STATUS_REPORT': '33', 'CARTERA_HEALTH_360': '37',
      'PLANS_REPORT': '22', 'BDV_BP_TRANSACTIONS': '23',
      'SAP_P': '8', 'SAP_G': '9', 'SAP_BP': '43', 'SAP_PARTIDAS_ABIERTAS': '44', 'SAP_PERDIDAS_INCOBRABLES': '45'
    };
    return map[reportType] || null;
  }

  // Click en un proceso en curso → selecciona el tipo en el form
  // Reporte del select (por producto: hay valores repetidos entre Crédito y Seguros) →
  // código base de su permiso. Cada reporte tiene tres acciones: .export (ver y
  // descargar), .generate (botón "Generar Reporte") y .stop (botón "Detener").
  private static readonly PERMISO_REPORTE: Record<string, Record<string, string>> = {
    CREDIT: {
      '6': 'reportes.cartera_clientes', '3': 'reportes.cartera_credito', '7': 'reportes.clientes_domiciliados',
      '2': 'reportes.cuotas', '15': 'reportes.distribucion_pagos', '20': 'reportes.biometria', '4': 'reportes.pagos',
      '17': 'reportes.estadistica_registros', '18': 'reportes.pagos_penalidades', '19': 'reportes.penalidades',
      '33': 'reportes.fees_reactivacion', '37': 'reportes.cartera_360', '22': 'reportes.planes_clientes',
      '23': 'reportes.bdv_transacciones', '8': 'reportes.pagos_sap', '9': 'reportes.giros_sap',
      '46': 'reportes.pagos_sap_nuevo', '48': 'reportes.pagos_sap_perdidas_incobrables', '47': 'reportes.giros_sap_nuevo',
      '43': 'reportes.sap_business_partner', '44': 'reportes.sap_partidas_abiertas', '45': 'reportes.sap_perdidas_incobrables',
    },
    INSURANCE: {
      '21': 'reportes.seguros', '7': 'reportes.clientes_domiciliados', '24': 'reportes.pagos_seguros',
      '37': 'reportes.pagos_seguros', '38': 'reportes.pagos_seguros', '39': 'reportes.pagos_seguros',
      '35': 'reportes.operativo_seguros', '36': 'reportes.operativo_seguros',
      '32': 'reportes.operativo_seguros_caracas', '34': 'reportes.operativo_seguros_caracas', '40': 'reportes.operativo_seguros_caracas',
      '29': 'reportes.cartera_seguros', '30': 'reportes.pagos_seguro_kredit', '31': 'reportes.cuotas_seguros',
      '41': 'reportes.sap_mercantil_insurer', '42': 'reportes.sap_caracas_insurer',
      '25': 'reportes.sap_bdv_seguros', '26': 'reportes.sap_mercantil_seguros', '28': 'reportes.sap_plaza_seguros',
    },
  };

  permisoReporte(type: any = this.type, product: string = this.productType): string | null {
    return ExportComponent.PERMISO_REPORTE[product]?.[String(type)] || null;
  }

  puedeAccionReporte(accion: 'export' | 'generate' | 'stop', type: any = this.type, product: string = this.productType): boolean {
    const base = this.permisoReporte(type, product);
    return !!base && this._auth.hasPermission(`${base}.${accion}`);
  }

  /** Procesos en curso solo de los reportes que el usuario puede ver. */
  get procesosVisibles(): any[] {
    return (this.activeProcesses || []).filter((p: any) => {
      const v = this._reportTypeToFormValue(p?.type);
      return !!v && ['CREDIT', 'INSURANCE'].some((pr) => this.puedeAccionReporte('export', v, pr));
    });
  }

  selectActiveProcess(p: any) {
    const value = this._reportTypeToFormValue(p?.type);
    if (value) {
      this.type = value;
      this.setNewType();
      // Scroll al form (opcional)
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) {}
    }
  }

  // 🆕 2026-05-24 — Preservar un reporte tras COMPLETE (con nombre custom)
  async preserveTrace(item: any) {
    if (!item?._id) return;
    const defaultName = `${this.getFriendlyReportName(item?.type)} — ${new Date(item?.date_end).toLocaleDateString('es-VE')}`;
    const customName = window.prompt(
      'Asigna un nombre para preservar este reporte (ej. "Cierre noviembre 2026"):\n\nQuedará excluido del cleanup automático y siempre disponible para descarga.',
      defaultName
    );
    if (customName === null) return; // canceló
    try {
      const result = await this._user.preserveTrace(item._id, customName?.trim() || null);
      if (result?.ok) {
        // Refrescar lista
        if (this._tracePollType) this.getTrace_documets(this._tracePollType);
      } else {
        window.alert(result?.msg || 'No se pudo preservar');
      }
    } catch (err) {
      console.error('preserveTrace error:', err);
      window.alert('Error de red al preservar');
    }
  }

  async unpreserveTrace(item: any) {
    if (!item?._id) return;
    if (!window.confirm('¿Quitar preservación de este reporte? Volverá al pool del cleanup automático.')) return;
    try {
      await this._user.unpreserveTrace(item._id);
      if (this._tracePollType) this.getTrace_documets(this._tracePollType);
      // Refrescar también el drawer si está abierto
      if (this.historyDrawerOpen) this.loadHistory();
    } catch (err) {
      console.error('unpreserveTrace error:', err);
    }
  }

  // 🆕 2026-05-24 — Filtro preservados en el drawer del historial
  historyFilterPreserved: '' | 'true' | 'false' = '';
  async applyPreservedFilter() {
    this.historyPage = 1;
    await this.loadHistory();
  }

  dateSetting: MbscDatetimeOptions = {
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light',
    responsive: {
      small: {
          controls: ['calendar'],
          display: 'center'
      },
      medium: {
          display: 'bubble',
      }
  }

  };

  birthday = new Date();
  filterData:any = {f:new Date(),status:''}
  queryParams: any;
  person: any;
  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any;
  loading_person = false;
  loading = false;

  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
   type_approved: any;
   clientQuota:any;
   invoiceCredits: any = [];
   resp_invoiceCredits: any = [];
   installments: any = [];
   installmentNexPayment :any;
    view = 1;
    invoiceSelected:any;
    installMentSelected:any;
    payment:any;
    stadistic:any;

    productArray:any[] = [];

  // === FILTRO SIMPLE DE TIPO DE PRODUCTO ===
  productType: string = 'CREDIT'; // 'CREDIT' o 'INSURANCE'

  // === FILTRO MÚLTIPLE DE PRODUCTOS - Propiedades (COMENTADO) ===
  selectedProducts: string[] = ['CREDIT']; // Productos seleccionados (estado final)
  showDropdown: boolean = false; // Visibilidad del dropdown
  tempSelectedProducts: string[] = []; // Productos temporales (antes de aplicar)

  // === SISTEMA DE ESTADOS PROFESIONAL ===
  filterStates = {
    isLoadingProducts: false,    // Cargando lista de productos
    isApplyingFilter: false,     // Aplicando filtro seleccionado
    isLoadingResults: false,     // Cargando resultados de reportes
    hasError: false,             // Estado de error
    errorMessage: '',            // Mensaje de error específico
    isInitialized: false         // Si el filtro ya se inicializó
  };

  // Estados de animación
  dropdownAnimation = {
    isOpening: false,
    isClosing: false
  };

  // Legacy property for compatibility
  typeProduct: string = 'CREDIT';

  // 💎 BÚSQUEDA DE PRODUCTOS - Propiedades
  productSearchTerm: string = '';
  filteredProductArray: any[] = [];

  date_base: any = new Date;
  date_base_string :any;

  // 🆕 Fecha (día único) para reportes SAP por día (Pagos/Giros SAP y sus variantes Nuevo/Incobrables).
  // Se envía al backend como 'YYYY-MM-DD'; el backend hace new Date(date) y toma ese día completo.
  sapDate: string = '';

  mobileSettings: MbscDatetimeOptions = {
    display: 'bottom',
    themeVariant: 'dark',
};


desktopSettings: MbscDatetimeOptions = {
    display: 'bubble',
    touchUi: false
};

loadingXls:any;
loadingXls2:any;
type:any = '';  // sin reporte por defecto: se elige uno de los permitidos
env:any = environment;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    private elementRef: ElementRef,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    this.date_base_string = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');

    // 🆕 Inicializar la fecha de reportes SAP por día en HOY (formato YYYY-MM-DD para <input type="date">).
    this.sapDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '';

    // 🆕 2026-05-23 — Cargar stats históricas para "tiempo aproximado" en cards
    this.loadTraceStats();

    // 🆕 2026-05-24 — Polling global de procesos en curso (PENDING todos los tipos)
    this._startActiveProcessesPolling();

    // Inicializar productType con el primer tipo de reporte disponible
    if (this.hasAnyCreditReport()) {
      this.productType = 'CREDIT';
    } else if (this.hasAnyInsuranceReport()) {
      this.productType = 'INSURANCE';
    }

    this.loading_person = true;
    this.setNewType();

    this.initializeProductFilter();
  }


  getStadisticServer = async () => {
    try{
        return this._user.getstadistic_invice_status();

      } catch (error) {
        console.error(error);


      }
  }


  // Permisos granulares de reportes
  private creditReportPermissions = [
    'reportes.cartera_clientes.export', 'reportes.cartera_credito.export',
    'reportes.clientes_domiciliados.export', 'reportes.cuotas.export',
    'reportes.distribucion_pagos.export', 'reportes.biometria.export',
    'reportes.pagos.export', 'reportes.estadistica_registros.export',
    'reportes.pagos_penalidades.export', 'reportes.penalidades.export',
    'reportes.planes_clientes.export', 'reportes.bdv_transacciones.export',
    'reportes.pagos_sap.export', 'reportes.giros_sap.export',
    'reportes.pagos_sap_nuevo.export', 'reportes.giros_sap_nuevo.export',
    'reportes.cartera_360.export'
  ];

  private insuranceReportPermissions = [
    'reportes.seguros.export', 'reportes.pagos_seguros.export',
    'reportes.operativo_seguros.export', 'reportes.cartera_seguros.export',
    'reportes.pagos_seguro_kredit.export', 'reportes.cuotas_seguros.export',
    'reportes.sap_bdv_seguros.export', 'reportes.sap_mercantil_seguros.export',
    'reportes.sap_plaza_seguros.export'
  ];

  hasAnyCreditReport(): boolean {
    return this._auth.hasAnyPermission(this.creditReportPermissions);
  }

  hasAnyInsuranceReport(): boolean {
    return this._auth.hasAnyPermission(this.insuranceReportPermissions);
  }

  getListInvoiceCredits = async () => {
    try {

      const resp_invoiceCredits = await this.listInvoiceCredits();

      this.resp_invoiceCredits = resp_invoiceCredits?.res;

      const resp = await this.getStadisticServer();
      this.stadistic = resp?.res;


    } catch (error) {
      console.error(error);

    }


    this.loading_person = false;


  }


  listInvoiceCredits = async () => {
    try{


        return this._user.listInvoiceCredits(this.filterData);

      } catch (error) {
        console.error(error);


      }
  }



  getPersonInstallmentsInvoiceCredits = async (invoice:any) => {
    this.loading = true;

    this.invoiceSelected = invoice;
    try {
         const data =  {
          code_invoice:invoice?.code

         }
       const  installments  = await this._user.getPersonInstallmentsInvoiceCredits(data);

       this.installments = installments?.res;

       this.installments.map((value:any, index:any) => {
        if(value?.installMent?.payment_status?.code != 'PaymentComplete' && !this.installmentNexPayment){

          this.installmentNexPayment = value?.installMent?.code;

        }

        value["totalpaymentReference"] = 0;

        value?.paymentReference?.forEach((value2:any) =>{
          value["totalpaymentReference"] =  value["totalpaymentReference"]  +  value2?.payment?.amount;
        });



        return value;
      });



/*
      this.installments.sort((a:any, b:any) => {
        let temp = a?.installMent?.order;
        let temp2 = b?.installMent?.order;

        return  temp - temp2;
      });*/


       this.view = 2;

      } catch (error) {
        console.error(error);

      }

      this.loading = false;

  }


  getPersonInstallmentpayment = async (installMentSelected:any) => {

    this.loading = true;

    this.installMentSelected = installMentSelected;
    try {
         const data =  {
          code_installMent:installMentSelected?.code

         }

       const  payment  = await this._user.getPersonInstallmentpayment(data);

       this.payment = payment?.res;
       this.view = 3;

      } catch (error) {
        console.error(error);


      }

      this.loading = false;

  }


  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

  }


  getContact(item: any) {

    if (!(item?.constacts?.length > 0))
      return "";

    return `${item?.constacts[0]?.contact}`;


  }


  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }



  public redirect = () => {

    let Doc_ID;
    let Type_ID;
    let TLF;


    if (this.person?.identitys?.length > 0) {

      const data = this.person?.identitys[0];
      Type_ID = data.type_identity?.additionalType;
      Doc_ID = data.identity;

    }


    const data = {

      CED: environment.CED,
      IP: environment.IP_LOCAL,
      Type_ID,
      Doc_ID,
      PN: this.person?.person?.name,
      PA: this.person?.person?.lastName,
      FN: this.datePipe.transform(this.person?.person?.birth_date, 'yyyy-MM-dd'),
      GN: this.person?.person?.gender,
      TLF: "",
      EMAIL: ""

    }

    this.redirecFormService.postRedirect(environment.externalPsicometrico, data);

  }

  closeInstallment(){

    if(this.view == 2 ){
      this.installments = [];
      this.view = 1;
      this.invoiceSelected=null;
      this.installmentNexPayment = null;

    }else  if(this.view == 3 ){
      this.view = 2;
      this.installMentSelected = null;
      this.payment = null;
      this.installmentNexPayment = null;

    }

         }



redirectTo(code:any) {
  this.router.navigate([`/console/payments/person/${code}`], {});
}

 public generate_csv   =  async () =>{

  this.loadingXls = true;
  try {
  const  array_name  = await this._user.getInstallMentsFN({f:this.date_base_string});
  this.loadingXls = false;

  debugger

  array_name?.res?.map((value:any)=>{
    const timestamp = new Date().getTime();
    let url = `${environment.BASE_LA}/csv/${value?.ruta}?t=${timestamp}`;
    window.open(`${url}`);

  })

  } catch (error) {

    this.loadingXls = false;


  }

}


public generate_installment_csv   =  async () =>{

  this.loadingXls2 = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


   await this._user.getInstallMents_statusFN(
    {
      init:this.d1,
      end:this.d2
    });
  this.loadingXls2 = false;



   const timestamp = new Date().getTime();
   let url = `${environment.BASE_LA}/csv/installments_status.xlsx?t=${timestamp}`;
   window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}



dateSet(e: any) {

  this.resetFilter();

  this.filterData.f = this.date_base;


  let date_base =  e.valueText;

  let  temp = date_base? date_base.split("/") : [];
  this.date_base_string = `${temp[1]}/${temp[0]}/${temp[2]}`;



}

filter = async () => {

  const resp_invoiceCredits = await this.listInvoiceCredits();
  this.resp_invoiceCredits = resp_invoiceCredits?.res;

}


  // simple handler without any parameters
  birthdaySet() {


  this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
  this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

  debugger

    }

resetFilter(){

  this.filterData = {f:new Date(),status:''};

}

nonFormSettings: MbscRangeOptions = {
  showSelector: false
};

externalSettings: MbscRangeOptions = {
  showOnTap: false,
  showOnFocus: false,
  showSelector: false
};



public generate_invoices_csv   =  async () =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    try {

      let result = await this._user.getAllInvoicesReportGet(
        {
          init:this.d1,
          end:this.d2
        });


        this.getTrace_documets('INVOICES_1');


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;



   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}


public generate_payments_csv   =  async (type:any = '') =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    try {

      let result = await this._user.allPaymentsReportGet(
        {
          init:this.d1,
          end:this.d2,
          type
        });

        if(type == 'U'){
          this.getTrace_documets('PAYMETS_S3');

        }else{
          this.getTrace_documets('PAYMETS_S2');

        }


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;



   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

public generate_payments_fee_csv   =  async (type:any = '') =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    try {

      let result = await this._user.allFeesPaymentsReportGet(
        {
          init:this.d1,
          end:this.d2,
          type
        });

        if(type == 'U'){
          this.getTrace_documets('FEES_PAYMENTS_REPORT');

        }else{
          this.getTrace_documets('FEES_PAYMENTS_REPORT');

        }


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;



   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}


public generate_payments_fee_v2_csv   =  async (type:any = '') =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    try {

      let result = await this._user.allFeesPaymentsReportV2Get(
        {
          init:this.d1,
          end:this.d2,
          type
        });

        if(type == 'U'){
          this.getTrace_documets('FEES_PAYMENTS_REPORT_V2');

        }else{
          this.getTrace_documets('FEES_PAYMENTS_REPORT_V2');

        }


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;



   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

// Ajuste 18 — Reporte V3 de Penalidades (12 cols originales + 6 nuevas = 18 cols).
public generate_payments_fee_v3_csv = async (type: any = '') => {
  this.loadingXls = true;
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {
      await this._user.allFeesPaymentsReportV3Get({
        initDate: this.d1,
        endDate: this.d2,
        conceptDeductionCodeConcept: type === 'PENALIDAD' ? 'C001' : 'ALL'
      });
      this.getTrace_documets('FEES_PAYMENTS_REPORT_V3');
    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;
  } catch (error) {
    this.loadingXls2 = false;
  }
}

public generate_reactivation_fees_status_csv = async () => {

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {

      let result = await this._user.reactivationFeesStatusReportGet(
        {
          initDate: this.d1,
          endDate: this.d2
        });

      this.getTrace_documets('REACTIVATION_FEES_STATUS_REPORT');

    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {

    this.loadingXls = false;

  }

}


public generate_clients_csv   =  async () =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {


      let result = await this._user.allclientsReportGet(
        {
          init:this.d1,
          end:this.d2,
        });

          this.getTrace_documets('CLIENT_1');


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}


public generate_clients_domic_csv   =  async () =>{

  this.loadingXls = true;
  try {

    try {

      // Reporte histórico: no envía rango de fechas. Solo filtra por tipo de producto.
      let result = await this._user.clientsdomicReportGet(
        {
          approved_status: this.status_approved,
          product_type: this.domiciliation_product_type
        });


          this.getTrace_documets('CLIENT_2', this.domiciliation_product_type);

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;

  } catch (error) {

    this.loadingXls2 = false;


  }

}


public generate_dist_payments_csv   =  async () =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {

  //accounts_person_report
      let result = await this._user.dist_paymentsReportGet(
        {
          init:this.d1,
          end:this.d2
        });


          this.getTrace_documets('DIST_PAYMENTS');

        debugger

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}


public generate_cliente_stadistic_csv   =  async () =>{

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {

  //accounts_person_report
      let result = await this._user.clientEstadisticReportGet(
        {
          //init:this.d1,
        //  end:this.d2
        });


          this.getTrace_documets('CLIENT_STADITIC');

        debugger

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

public generate_sap_payments_csv =  async () =>{

  this.loadingXls = true;
  try {

    let d1 = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');

    try {

  //accounts_person_report
      let result = await this._user.sapPaymentsReportGet(
        {
          date:this.sapDate

        });


          this.getTrace_documets('SAP_P');

        debugger

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

generate_sap_giros_csv =  async () =>{

  this.loadingXls = true;
  try {

    let d1 = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');

    try {

  //accounts_person_report
      let result = await this._user.sapGirosReportGet(
        {
          date:this.sapDate

        });


          this.getTrace_documets('SAP_G');

        debugger

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

// 🆕 Copias "Nuevo" de Pagos/Giros SAP (sin encabezado + formato de columnas).
generate_sap_payments_nuevo_csv = async () => {
  this.loadingXls = true;
  try {
    try {
      await this._user.sapPaymentsNuevoReportGet({ date: this.sapDate });
      this.getTrace_documets('SAP_P_NUEVO');
    } catch (error) {
      console.log(error);
    }
    this.loadingXls = false;
  } catch (error) {
    this.loadingXls2 = false;
  }
}

// 🆕 Reporte Pagos SAP Pérdidas Incobrables (formato Nuevo, filtrado a cartera castigada).
generate_sap_payments_perdidas_incobrables_csv = async () => {
  this.loadingXls = true;
  try {
    try {
      await this._user.sapPaymentsPerdidasIncobrablesReportGet({ date: this.sapDate });
      this.getTrace_documets('SAP_P_PERDIDAS_INCOBRABLES');
    } catch (error) {
      console.log(error);
    }
    this.loadingXls = false;
  } catch (error) {
    this.loadingXls2 = false;
  }
}

generate_sap_giros_nuevo_csv = async () => {
  this.loadingXls = true;
  try {
    try {
      await this._user.sapGirosNuevoReportGet({ date: this.sapDate });
      this.getTrace_documets('SAP_G_NUEVO');
    } catch (error) {
      console.log(error);
    }
    this.loadingXls = false;
  } catch (error) {
    this.loadingXls2 = false;
  }
}

// 🆕 Reporte SAP Business Partner (datos maestros de clientes). Sin fecha (universo completo).
generate_sap_business_partner_csv = async () => {

  this.loadingXls = true;
  try {

    try {
      await this._user.sapBusinessPartnerReportGet();
      this.getTrace_documets('SAP_BP');
    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {

    this.loadingXls2 = false;

  }

}

// 🆕 Reporte SAP de Partidas Abiertas (SALDOS INIC CRED T). Sin fecha (piso fijo 17/12/2025).
generate_sap_partidas_abiertas_csv = async () => {

  this.loadingXls = true;
  try {

    try {
      await this._user.sapPartidasAbiertasReportGet();
      this.getTrace_documets('SAP_PARTIDAS_ABIERTAS');
    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {

    this.loadingXls2 = false;

  }

}

// 🆕 Reporte SAP de Pérdidas Incobrables. Sin fecha (todos los créditos <= 16/12/2025).
generate_sap_perdidas_incobrables_csv = async () => {

  this.loadingXls = true;
  try {

    try {
      await this._user.sapPerdidasIncobrablesReportGet();
      this.getTrace_documets('SAP_PERDIDAS_INCOBRABLES');
    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {

    this.loadingXls2 = false;

  }

}

/**
 * 📊 Reporte SAP Pagos BDV - Seguros
 * Genera reporte de pagos de seguros procesados por Banco de Venezuela
 */
public generate_sap_payments_bdv_csv = async () => {
  this.loadingXls = true;
  try {
    // Formatear fechas a YYYY-MM-DD
    const initDate = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');

    try {
      let result = await this._user.sapPaymentsBdvReportGet({
        initDate: initDate,
        endDate: endDate
      });

      this.getTrace_documets('SAP_P_BDV');

    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {
    this.loadingXls = false;
  }
}

/**
 * 📊 Reporte SAP Pagos Mercantil - Seguros
 * Genera reporte de pagos de seguros procesados por Banco Mercantil
 */
public generate_sap_payments_mercantil_csv = async () => {
  this.loadingXls = true;
  try {
    // Formatear fechas a YYYY-MM-DD
    const initDate = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');

    try {
      let result = await this._user.sapPaymentsMercantilReportGet({
        initDate: initDate,
        endDate: endDate
      });

      this.getTrace_documets('SAP_P_MERCANTIL');

    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {
    this.loadingXls = false;
  }
}

/**
 * 📊 Reporte SAP Pagos Banco Plaza - Seguros
 * Genera reporte de pagos de seguros procesados por Banco Plaza
 */
public generate_sap_payments_banco_plaza_csv = async () => {
  this.loadingXls = true;
  try {
    // Formatear fechas a YYYY-MM-DD
    const initDate = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');

    try {
      let result = await this._user.sapPaymentsBancoPlazaReportGet({
        initDate: initDate,
        endDate: endDate
      });

      this.getTrace_documets('SAP_P_BANCO_PLAZA');

    } catch (error) {
      console.log(error);
    }

    this.loadingXls = false;

  } catch (error) {
    this.loadingXls = false;
  }
}

/**
 * 📊 Reporte SAP Pagos consolidado - Seguros Mercantil (los 3 bancos en un archivo)
 */
public generate_sap_payments_mercantil_insurer_csv = async () => {
  this.loadingXls = true;
  try {
    const initDate = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');
    try {
      await this._user.sapPaymentsMercantilInsurerReportGet({ initDate, endDate });
      this.getTrace_documets('SAP_P_MERCANTIL_SEGUROS');
    } catch (error) { console.log(error); }
    this.loadingXls = false;
  } catch (error) { this.loadingXls = false; }
}

/**
 * 📊 Reporte SAP Pagos consolidado - Seguros Caracas (los 3 bancos en un archivo)
 */
public generate_sap_payments_caracas_insurer_csv = async () => {
  this.loadingXls = true;
  try {
    const initDate = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');
    try {
      await this._user.sapPaymentsCaracasInsurerReportGet({ initDate, endDate });
      this.getTrace_documets('SAP_P_CARACAS_SEGUROS');
    } catch (error) { console.log(error); }
    this.loadingXls = false;
  } catch (error) { this.loadingXls = false; }
}

public generate_report_biometric = async () =>{

  debugger;

  this.loadingXls = true;
  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    try {

  //accounts_person_report
      let result = await this._user.report_biometricGet(
        {
          init_date:this.d1,
          end_date:this.d2
        });


          this.getTrace_documets('BIOMETRIC');

        debugger

    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;


   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

// 🆕 2026-05-24 — Bloqueo: si hay un PENDING del MISMO tipo corriendo,
// no se permite generar otro. Pregunta si quiere detener el anterior con razón.
async generate(){
  if (!this.type || !this.puedeAccionReporte('generate')) return;

  // Mapear el value del form al enum del backend
  const value = String(this.type);
  const valueToEnum: Record<string, string> = {
    '2': 'INSTALLMENT_1', '3': 'INVOICES_1', '4': 'PAYMETS_S2', '5': 'PAYMETS_S3',
    '6': 'CLIENT_1', '7': 'CLIENT_2', '8': 'SAP_P', '9': 'SAP_G',
    '15': 'DIST_PAYMENTS', '17': 'CLIENT_STADITIC', '18': 'FEES_PAYMENTS_REPORT',
    '19': 'FEES_PAYMENTS_REPORT_V3', '20': 'BIOMETRIC',
    '22': 'PLANS_REPORT', '23': 'BDV_BP_TRANSACTIONS',
    '33': 'REACTIVATION_FEES_STATUS_REPORT', '37': 'CARTERA_HEALTH_360', '43': 'SAP_BP',
    '44': 'SAP_PARTIDAS_ABIERTAS', '45': 'SAP_PERDIDAS_INCOBRABLES'
  };
  const targetEnum = valueToEnum[value];

  // 🆕 Validación de fecha para reportes SAP por día (Pagos/Giros SAP y variantes Nuevo/Incobrables).
  // Requieren un día único; si no hay fecha elegida, bloquear con aviso.
  const perDaySapTypes = ['8', '9', '46', '47', '48'];
  if (perDaySapTypes.includes(value) && !this.sapDate) {
    Swal.fire({
      icon: 'warning',
      title: 'Selecciona una fecha',
      text: 'Debes elegir el día para generar este reporte SAP.'
    });
    return;
  }

  // Si hay un PENDING del mismo tipo, bloquear y ofrecer cancelar el anterior
  if (targetEnum) {
    const inFlight = (this.activeProcesses || []).find(
      (p: any) => p?.type === targetEnum && p?.state === 'PENDING' && !p?.cancel_requested
    );
    if (inFlight) {
      const ok = window.confirm(
        `Ya hay un "${this.getFriendlyReportName(targetEnum)}" en curso (${this.getElapsedHuman(inFlight?.date_start)} transcurridos).\n\n¿Detener el actual y generar uno nuevo?`
      );
      if (!ok) return;
      // Pide razón y cancela primero
      await this.cancelTrace(inFlight);
      // Esperar un tick para que el backend marque CANCELED instantáneo
      await new Promise(r => setTimeout(r, 300));
    }
  }

  this.loadingXls = true;
  switch (String(this.type)) {
    case '1':
    this.generate_csv();
      break;
    case '2':
    this.generate_installments2_csv();
      break;
    case '3':
    this.generate_invoices_csv();
      break;
    case '4':
    this.generate_payments_csv();
      break;
    case '5':
    this.generate_payments_csv('U');
      break;
    case '6':
    this.generate_clients_csv();
      break;
    case '7':
    this.generate_clients_domic_csv();
      break;
    case '8':
    this.generate_sap_payments_csv();
      break;
    case '9':
    this.generate_sap_giros_csv();
      break;
    case '46':
    this.generate_sap_payments_nuevo_csv();
      break;
    case '48':
    this.generate_sap_payments_perdidas_incobrables_csv();
      break;
    case '47':
    this.generate_sap_giros_nuevo_csv();
      break;
    case '43':
    this.generate_sap_business_partner_csv();
      break;
    case '44':
    this.generate_sap_partidas_abiertas_csv();
      break;
    case '45':
    this.generate_sap_perdidas_incobrables_csv();
      break;
    case '15':
    this.generate_dist_payments_csv();
      break;
    case '17':
    this.generate_cliente_stadistic_csv();
      break;
    case '18':
      this.generate_payments_fee_csv('ALL');
      break;
    case '19':
      // Ajuste 18 — usar V3 (18 columnas) en lugar de V2 (12 columnas)
      this.generate_payments_fee_v3_csv('PENALIDAD');
      break;
    case '20':
      this.generate_report_biometric();
      break;
    case '21':
      this.generate_insurance_report_csv();
      break;
    case '22':
      this.generate_report_plans_by_clients();
      break;
    case '24':
      this.generate_insurance_payments_report_csv();
      break;
    case '25':
      this.generate_sap_payments_bdv_csv();
      break;
    case '26':
      this.generate_sap_payments_mercantil_csv();
      break;
    case '27':
      this.generate_insurance_operative_report_csv();
      break;
    case '28':
      this.generate_sap_payments_banco_plaza_csv();
      break;
    case '29':
      this.generate_insurance_invoices_report_csv();
      break;
    case '30':
      this.generate_insurance_payments_kredit_report_csv();
      break;
    case '31':
      this.generate_insurance_installments_report_csv();
      break;
    case '32':
      this.generate_insurance_operative_report_caracas_csv();
      break;
    case '33':
      this.generate_reactivation_fees_status_csv();
      break;
    case '34':
      this.generate_insurance_operative_report_caracas11_csv();
      break;
    case '35':
      this.generate_insurance_operative_report_sm_creditotal_csv();
      break;
    case '36':
      this.generate_insurance_operative_report_sm_portal_externo_csv();
      break;
    case '37':
      this.generate_cartera_health_360_csv();
      break;
    case '39':
      this.generate_insurance_payments_report_sc_csv();
      break;
    case '40':
      this.generate_insurance_operative_report_caracas_v2_csv();
      break;
    case '41':
      this.generate_sap_payments_mercantil_insurer_csv();
      break;
    case '42':
      this.generate_sap_payments_caracas_insurer_csv();
      break;
    // case '38':
    //   this.generate_insurance_payments_report_sc11_csv();
    //   break;
    default:
      this.loadingXls = false;
      break;
  }

}

// Ajuste 19 — Reporte 360 de Salud de Cartera (multi-pestaña + predictivo + NIIF 9)
public generate_cartera_health_360_csv = async () => {
  this.loadingXls = true;
  try {
    await this._user.carteraHealth360Get();
    this.getTrace_documets('CARTERA_HEALTH_360');
  } catch (error) {
    console.log(error);
  } finally {
    this.loadingXls = false;
  }
}


public generate_insurance_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_report_csv(this.d1, this.d2);
    
    // Si es exitoso, consultar inmediatamente
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE');
  } catch (error) {
    console.error('Error en generateInsuranceReportService:', error);
    
    // Si hay error, esperar un poco para que el backend registre el estado de error
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE');
      this.loadingXls = false;
    }, 1000); // Esperar 1 segundo
  }
}

public generate_insurance_payments_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_payments_report_csv(this.d1, this.d2);

    // Si es exitoso, consultar inmediatamente
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_PAYMENTS');
  } catch (error) {
    console.error('Error en generateInsurancePaymentsReportService:', error);

    // Si hay error, esperar un poco para que el backend registre el estado de error
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_PAYMENTS');
      this.loadingXls = false;
    }, 1000); // Esperar 1 segundo
  }
}

public generate_insurance_operative_report_caracas_v2_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_caracas_v2_csv(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_V2');
  } catch (error) {
    console.error('Error en generateOperativeInsuranceReportCaracasV2Service:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_V2');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_payments_report_sc_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_payments_report_sc_csv(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_PAYMENTS_SC');
  } catch (error) {
    console.error('Error en generateInsurancePaymentsReportSCService:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_PAYMENTS_SC');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_payments_report_sc10_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_payments_report_sc10_csv(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_PAYMENTS_SC10');
  } catch (error) {
    console.error('Error en generateInsurancePaymentsReportSC10Service:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_PAYMENTS_SC10');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_payments_report_sc11_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_payments_report_sc11_csv(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_PAYMENTS_SC11');
  } catch (error) {
    console.error('Error en generateInsurancePaymentsReportSC11Service:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_PAYMENTS_SC11');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_invoices_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.insuranceInvoicesReportGet(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_INVOICES');
  } catch (error) {
    console.error('Error en generate_insurance_invoices_report_csv:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_INVOICES');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_payments_kredit_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.insurancePaymentsReportGet(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_PAYMENTS');
  } catch (error) {
    console.error('Error en generate_insurance_payments_kredit_report_csv:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_PAYMENTS');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_installments_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.insuranceInstallmentsReportGet(this.d1, this.d2);
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_INSTALLMENTS');
  } catch (error) {
    console.error('Error en generate_insurance_installments_report_csv:', error);
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_INSTALLMENTS');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_operative_report_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_csv(this.d1, this.d2);
    
    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT');
  } catch (error) {
    console.error('Error en generateInsuranceOperativeReportService:', error);
    
    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_operative_report_caracas_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_caracas_csv(this.d1, this.d2);

    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS');
  } catch (error) {
    console.error('Error en generateInsuranceOperativeReportCaracasService:', error);

    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_operative_report_caracas11_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_caracas11_csv(this.d1, this.d2);

    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_11');
  } catch (error) {
    console.error('Error en generateInsuranceOperativeReportCaracas11Service:', error);

    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_11');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_operative_report_sm_creditotal_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_sm_creditotal_csv(this.d1, this.d2);

    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_CREDITOTAL');
  } catch (error) {
    console.error('Error en generateOperativeInsuranceReportSMCreditotalService:', error);

    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_CREDITOTAL');
      this.loadingXls = false;
    }, 1000);
  }
}

public generate_insurance_operative_report_sm_portal_externo_csv = async () => {
  try {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    await this._user.generate_insurance_operative_report_sm_portal_externo_csv(this.d1, this.d2);

    this.loadingXls = false;
    this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_PORTAL_EXTERNO');
  } catch (error) {
    console.error('Error en generateOperativeInsuranceReportSMPortalExternoService:', error);

    setTimeout(async () => {
      await this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_PORTAL_EXTERNO');
      this.loadingXls = false;
    }, 1000);
  }
}

  async generate_report_plans_by_clients() {
    this.loadingXls = true;
    try {

      this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
      this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

      try {


        let result = await this._user.allclientsPlansReportGet(
          {
            init:this.d1,
            end:this.d2,
          });

            this.getTrace_documets('PLANS_REPORT');


      } catch (error) {
        console.log(error);


      }


    this.loadingXls = false;


     //let url = `${environment.BASE_LA}/${result}`;
   //  window.open(`${url}`);

    } catch (error) {

      this.loadingXls2 = false;


    }
  }


setNewType(){
  this.trace_documets = [];

  switch (String(this.type)) {
    case '2': this.getTrace_documets('INSTALLMENT_1'); break;
    case '3': this.getTrace_documets('INVOICES_1'); break;
    case '4': this.getTrace_documets('PAYMETS_S2'); break;
    case '5': this.getTrace_documets('PAYMETS_S3'); break;
    case '6': this.getTrace_documets('CLIENT_1'); break;
    case '7':
      // Para CREDIT no hay variantes: el valor del filtro siempre es 'CREDIT'.
      if (this.productType === 'CREDIT') this.domiciliation_product_type = 'CREDIT';
      this.getTrace_documets('CLIENT_2', this.domiciliation_product_type);
      break;
    case '8': this.getTrace_documets('SAP_P'); break;
    case '9': this.getTrace_documets('SAP_G'); break;
    case '46': this.getTrace_documets('SAP_P_NUEVO'); break;
    case '48': this.getTrace_documets('SAP_P_PERDIDAS_INCOBRABLES'); break;
    case '47': this.getTrace_documets('SAP_G_NUEVO'); break;
    case '43': this.getTrace_documets('SAP_BP'); break;
    case '44': this.getTrace_documets('SAP_PARTIDAS_ABIERTAS'); break;
    case '45': this.getTrace_documets('SAP_PERDIDAS_INCOBRABLES'); break;
    case '15': this.getTrace_documets('DIST_PAYMENTS'); break;
    case '17': this.getTrace_documets('CLIENT_STADITIC'); break;
    case '18': this.getTrace_documets('FEES_PAYMENTS_REPORT'); break;
    case '19': this.getTrace_documets('FEES_PAYMENTS_REPORT_V3'); break;
    case '20': this.getTrace_documets('BIOMETRIC'); break;
    case '21': this.getTrace_documets('INSURANCE'); break;
    case '22': this.getTrace_documets('PLANS_REPORT'); break;
    case '23': this.getTrace_documets('BDV_BP_TRANSACTIONS'); break;
    case '24': this.getTrace_documets('INSURANCE_PAYMENTS'); break;
    case '25': this.getTrace_documets('SAP_P_BDV'); break;
    case '26': this.getTrace_documets('SAP_P_MERCANTIL'); break;
    case '27': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT'); break;
    case '28': this.getTrace_documets('SAP_P_BANCO_PLAZA'); break;
    case '29': this.getTrace_documets('INSURANCE_INVOICES'); break;
    case '30': this.getTrace_documets('INSURANCE_PAYMENTS'); break;
    case '31': this.getTrace_documets('INSURANCE_INSTALLMENTS'); break;
    case '32': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS'); break;
    case '33': this.getTrace_documets('REACTIVATION_FEES_STATUS_REPORT'); break;
    case '34': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_11'); break;
    case '35': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_CREDITOTAL'); break;
    case '36': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_SM_PORTAL_EXTERNO'); break;
    case '37': this.getTrace_documets('CARTERA_HEALTH_360'); break;
    case '39': this.getTrace_documets('INSURANCE_PAYMENTS_SC'); break;
    case '40': this.getTrace_documets('INSURANCE_OPERATIVE_REPORT_CARACAS_V2'); break;
    case '41': this.getTrace_documets('SAP_P_MERCANTIL_SEGUROS'); break;
    case '42': this.getTrace_documets('SAP_P_CARACAS_SEGUROS'); break;
    // case '38': this.getTrace_documets('INSURANCE_PAYMENTS_SC11'); break;
  }

  const d1 = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');
}



// Polling timer + tipo actual para refrescar progress de PENDING en vivo
private _tracePollInterval: any = null;
private _tracePollType: string | null = null;

// 🆕 2026-05-23 — Cache de stats por tipo (servidas por /trace_documents/stats)
// Estructura: { [type]: { avg_min, min_min, max_min, count } }
traceStats: Record<string, any> = {};

async loadTraceStats() {
  try {
    const r = await this._user.traceDocumentsStatsGet();
    this.traceStats = r?.resp || {};
  } catch (err) {
    console.error('loadTraceStats error:', err);
  }
}

/**
 * Devuelve el promedio histórico de duración (en minutos) del tipo.
 * Prioriza el cache server-side (todos los COMPLETE). Si no hay stats
 * server-side, fallback al cálculo local con los traces visibles.
 */
getAvgDurationMin(type: string): number | null {
  if (!type) return null;
  // Server-side stats first (incluye TODOS los COMPLETE históricos)
  const serverStat = this.traceStats?.[type];
  if (serverStat?.avg_min != null && serverStat.count > 0) {
    return Math.round(serverStat.avg_min);
  }
  // Fallback: cálculo local con la lista visible
  if (!this.trace_documets?.length) return null;
  const completed = this.trace_documets
    .filter((t: any) => t?.type === type && t?.state === 'COMPLETE' && t?.date_start && t?.date_end)
    .map((t: any) => {
      const start = new Date(t.date_start).getTime();
      const end = new Date(t.date_end).getTime();
      return (end - start) / 60000;
    })
    .filter((m: number) => m > 0 && m < 600);
  if (completed.length === 0) return null;
  const avg = completed.reduce((s: number, m: number) => s + m, 0) / completed.length;
  return Math.round(avg);
}

// Devuelve el count de ejecuciones COMPLETE de un tipo (para tooltip "basado en N")
getStatCount(type: string): number {
  return this.traceStats?.[type]?.count || 0;
}

/** Convierte (now - date_start) a formato legible "3m 24s" / "1h 12m". */
getElapsedHuman(dateStart: any): string {
  if (!dateStart) return '—';
  const start = new Date(dateStart).getTime();
  if (isNaN(start)) return '—';
  const elapsedSec = Math.floor((Date.now() - start) / 1000);
  if (elapsedSec < 60) return `${elapsedSec}s`;
  if (elapsedSec < 3600) return `${Math.floor(elapsedSec / 60)}m ${elapsedSec % 60}s`;
  return `${Math.floor(elapsedSec / 3600)}h ${Math.floor((elapsedSec % 3600) / 60)}m`;
}

// 🆕 2026-05-23 — Cancelar un trace en ejecución (state=PENDING)
// 🆕 2026-05-24 — Requiere razón obligatoria (mín. 5 chars) para auditoría
async cancelTrace(item: any) {
  if (!this.puedeAccionReporte('stop')) return;
  if (!item?._id && !item?.code) {
    console.warn('cancelTrace: trace sin _id ni code');
    return;
  }
  const friendly = this.getFriendlyReportName(item?.type);
  const reason = window.prompt(
    `Vas a detener el reporte "${friendly}".\n\nIndica la razón (mínimo 5 caracteres):\n\nEjemplos:\n  • Se generó por error\n  • Necesito otro rango de fechas\n  • Está corriendo más de lo esperado\n  • Reemplazar con generación posterior`
  );
  if (reason === null) return; // canceló prompt
  const trimmed = (reason || '').trim();
  if (trimmed.length < 5) {
    window.alert('Razón muy corta (mínimo 5 caracteres). No se canceló.');
    return;
  }
  try {
    const result = await this._user.cancelTraceDocument(item?._id || item?.code, trimmed);
    if (result?.ok) {
      if (this._tracePollType) this.getTrace_documets(this._tracePollType);
      this.loadActiveProcesses();
    } else {
      window.alert(result?.msg || 'No se pudo cancelar el reporte');
    }
  } catch (err: any) {
    console.error('Error cancelando trace:', err);
    window.alert('Error de red al cancelar — reintentar en unos segundos');
  }
}

// Mapa de tipos de reporte a nombre humano para mostrar en UI.
// La lista debe sincronizarse con backend enum/typeTraceRouter.enum.js
private readonly REPORT_FRIENDLY_NAMES: Record<string, string> = {
  // Penalidades / Fees
  'FEES_PAYMENTS_REPORT_V3_STREAMING': 'Penalidades V3 — Streaming',
  'FEES_PAYMENTS_REPORT_V3':           'Penalidades V3',
  'FEES_PAYMENTS_REPORT_V2':           'Penalidades V2',
  'FEES_PAYMENTS_REPORT':              'Penalidades',
  // Cuotas
  'INSTALLMENT_1':                     'Reporte de Cuotas',
  'INSTALLMENT':                       'Cuotas',
  // Clientes
  'CLIENT_1':                          'Cartera de Clientes',
  'CLIENT_2':                          'Clientes Domiciliados',
  'CLIENT_STADITIC':                   'Estadística de Clientes',
  // Invoices / Cartera Crédito
  'INVOICES_1':                        'Cartera de Crédito',
  // Pagos
  'PAYMETS_S2':                        'Pagos',
  'PAYMETS_S3':                        'Pagos (variante 3)',
  'PAYMENT':                           'Pagos',
  'DIST_PAYMENTS':                     'Distribución de Pagos',
  // Cartera 360 + Reactivación
  'CARTERA_HEALTH_360':                'Cartera 360 — Salud + Predictivo',
  'REACTIVATION_FEES_STATUS_REPORT':   'Estado Reactivaciones (C004)',
  'REACTIVATION_FEES_STATUS':          'Estado Reactivaciones',
  // SAP
  'SAP_P':                             'SAP Pagos',
  'SAP_G':                             'SAP Giros',
  'SAP_BP':                            'SAP Business Partner',
  'SAP_PARTIDAS_ABIERTAS':             'SAP de Partidas Abiertas',
  'SAP_PERDIDAS_INCOBRABLES':          'SAP de Pérdidas Incobrables',
  'SAP_P_PERDIDAS_INCOBRABLES':        'SAP Pagos Pérdidas Incobrables',
  'SAP_P_INSURANCE':                   'SAP Pagos Seguros',
  'SAP_P_MERCANTIL_SEGUROS':           'SAP Pagos Mercantil Seguros',
  'SAP_P_CARACAS_SEGUROS':             'SAP Pagos Caracas Seguros',
  'REPORT_SAP_MERCANTIL':              'SAP Mercantil',
  'REPORT_SAP_BANCARIBE':              'SAP Bancaribe',
  'REPORT_SAP_BDV':                    'SAP BDV',
  // Domiciliación
  'DIRECTDEBIT_GENERATE_1':            'Domiciliación — Generar 1',
  'DIRECTDEBIT_GENERATE_2':            'Domiciliación — Generar 2',
  'DIRECTDEBIT_GENERATE_3':            'Domiciliación — Generar 3',
  'DIRECTDEBIT_UPLOAD_1':              'Domiciliación — Cargar 1',
  'DIRECTDEBIT_UPLOAD_2':              'Domiciliación — Cargar 2',
  'DIRECTDEBIT_UPLOAD_3':              'Domiciliación — Cargar 3',
  // Otros
  'PLANS_REPORT':                      'Reporte de Planes por Cliente',
  'BDV_BP_TRANSACTIONS':               'BDV BP Transacciones',
  'NOTIFICATION_1':                    'Notificaciones',
  'MASIVA':                            'Carga Masiva',
  'C004_MASSIVE_UPLOAD':               'C004 — Carga Masiva',
};

getFriendlyReportName(type: string): string {
  if (!type) return '—';
  return this.REPORT_FRIENDLY_NAMES[type] || type.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
}

// Conteo de traces por estado (para stats strip del header)
getTraceCountByState(state: string): number {
  if (!this.trace_documets?.length) return 0;
  return this.trace_documets.filter((t: any) => t?.state === state).length;
}

// Duración total (date_start → date_end), formato humano: "2h 15m 30s" / "45m 12s" / "12s"
getDurationHuman(dateStart: any, dateEnd: any): string {
  if (!dateStart || !dateEnd) return '—';
  const start = new Date(dateStart).getTime();
  const end = new Date(dateEnd).getTime();
  if (isNaN(start) || isNaN(end) || end < start) return '—';
  const sec = Math.floor((end - start) / 1000);
  if (sec < 60) return `${sec}s`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ${sec % 60}s`;
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${h}h ${m}m ${s}s`;
}

public getTrace_documets   =  async (type:any, product_type?:string) =>{

  this._tracePollType = type;
  try {
    try {

      // product_type es opcional: solo se usa para diferenciar reportes de Clientes
      // Domiciliados (CLIENT_2) que comparten type pero distinguen por tipo de producto.
      const params:any = { type };
      if (product_type) params.product_type = product_type;

      let result = await this._user.traceDocumentsGet(params);

      this.trace_documets = result.resp;

      // Si hay alguno PENDING, arrancar auto-poll cada 3s (progress bar live).
      // Si todos están COMPLETE/ERROR, detener el polling.
      const hasPending = (this.trace_documets || []).some((t: any) => t?.state === 'PENDING');
      if (hasPending) {
        this._startTracePolling();
      } else {
        this._stopTracePolling();
      }

    } catch (error) {
      console.log(error);


    }

  } catch (error) {

    this.loadingXls2 = false;


  }

}

private _startTracePolling() {
  if (this._tracePollInterval) return; // ya activo
  this._tracePollInterval = setInterval(async () => {
    if (!this._tracePollType) { this._stopTracePolling(); return; }
    try {
      const result = await this._user.traceDocumentsGet({ type: this._tracePollType });
      this.trace_documets = result.resp;
      // Re-sincronizar el trace seleccionado si está en la lista (estado/progress refrescados)
      if (this.selectedTrace?._id) {
        const updated = (this.trace_documets || []).find((t: any) => t?._id === this.selectedTrace._id);
        if (updated) this.selectedTrace = updated;
      }
      const stillPending = (this.trace_documets || []).some((t: any) => t?.state === 'PENDING');
      if (!stillPending) this._stopTracePolling();
    } catch (e) { /* silencioso, próximo tick reintenta */ }
  }, 3000);
}

private _stopTracePolling() {
  if (this._tracePollInterval) {
    clearInterval(this._tracePollInterval);
    this._tracePollInterval = null;
  }
}

ngOnDestroy() {
  this._stopTracePolling();
  this._stopActiveProcessesPolling();
}

dowloader_document(item:any){

  console.log(item);

  let api = environment.BASE_LA;
  const timestamp = new Date().getTime();


  if(item?.api == 'ONBOARDING-API'){

    api = environment.ONBOARDING_LA;

    let url_f = `${api}/${item?.url}?t=${timestamp}`;
    window.open(`${url_f}`);

  }else{
    let url_f = `${api}/${item?.url}?t=${timestamp}`;
    window.open(`${url_f}`);

  }

}

 addMinutes(date:any, minutes:any) {
  return new Date(date.getTime() + minutes*60000);
}



public generate_installments2_csv   =  async () =>{

  debugger
  this.loadingXls = true;

  try {

    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');


    try {


      await this._user.getInstallMents_statusFN(
        {
          init:this.d1,
          end:this.d2
        });

        this.getTrace_documets('INSTALLMENT_1');


    } catch (error) {
      console.log(error);


    }


  this.loadingXls = false;



   //let url = `${environment.BASE_LA}/${result}`;
 //  window.open(`${url}`);

  } catch (error) {

    this.loadingXls2 = false;


  }

}

/**
 * 📊 Generar reporte BDV BP Transacciones Encoladas
 */
public generate_bdv_transactions_csv = async () => {
  this.loadingXls = true; // Usar variable general como todos los reportes
  
  try {
    // 📅 Convertir fechas al formato yyyy-MM-dd que espera el backend
    this.d1 = this.datePipe.transform(this.range[0], 'yyyy-MM-dd');
    this.d2 = this.datePipe.transform(this.range[1], 'yyyy-MM-dd');

    console.log('📊 Generando reporte BDV BP Transacciones:', { startDate: this.d1, endDate: this.d2 });

    try {
      // 🚀 Llamar al endpoint del reporte BDV
      let result = await this._user.getBdvTransactionsReport({
        startDate: this.d1,
        endDate: this.d2
      });

      // 📋 Cargar trace documents para mostrar progreso
      this.getTrace_documets('BDV_BP_TRANSACTIONS');

      console.log('✅ Reporte BDV BP iniciado exitosamente');

    } catch (error) {
      console.error('❌ Error iniciando reporte BDV BP:', error);
    }

  } catch (error) {
    console.error('❌ Error en generate_bdv_transactions_csv:', error);
  }

  this.loadingXls = false; // Resetear variable general
};

// === INICIALIZACIÓN DEL FILTRO DE PRODUCTOS ===
async initializeProductFilter() {
  await this.consultAllProductsInvoices();
  // 💎 Actualizar el término de búsqueda con el filtro por defecto (CREDIT)
  this.updateSearchTermFromSelection();
}

async consultAllProductsInvoices(){
  try {
    this.filterStates.isLoadingProducts = true;
    this.filterStates.hasError = false;

    let consultProducts = await this._user.getTypesProductsInvoices();

    // Verificar que la respuesta sea válida
    if (consultProducts && consultProducts.resp && Array.isArray(consultProducts.resp)) {
      this.productArray = consultProducts.resp;
      this.filteredProductArray = [...this.productArray]; // Inicializar array filtrado
      this.tempSelectedProducts = [...this.selectedProducts]; // Inicializar temp
      this.filterStates.isInitialized = true;
      console.log('✅ Productos cargados:', this.productArray.length);
    } else {
      this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
      this.filteredProductArray = [...this.productArray];
      this.tempSelectedProducts = ['CREDIT'];
      this.filterStates.isInitialized = true;
    }

  } catch (error) {
    console.error('❌ ERROR: Error al cargar productos:', error);
    // No mostrar error al usuario, solo usar fallback
    this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
    this.filteredProductArray = [...this.productArray];
    this.tempSelectedProducts = ['CREDIT'];
    this.selectedProducts = ['CREDIT'];
    this.filterStates.isInitialized = true;
  } finally {
    this.filterStates.isLoadingProducts = false;
  }
}

// === MANEJO PROFESIONAL DEL DROPDOWN ===
async toggleDropdown() {
  if (this.showDropdown) {
    this.closeDropdown();
  } else {
    this.openDropdown();
  }
}

async openDropdown() {
  if (this.filterStates.isLoadingProducts) return;

  this.dropdownAnimation.isOpening = true;
  this.tempSelectedProducts = [...this.selectedProducts]; // Copia temporal

  // Pequeño delay para la animación
  setTimeout(() => {
    this.showDropdown = true;
    this.dropdownAnimation.isOpening = false;
  }, 50);
}

async closeDropdown() {
  this.dropdownAnimation.isClosing = true;

  setTimeout(() => {
    this.showDropdown = false;
    this.dropdownAnimation.isClosing = false;
    // Restaurar selección temporal si no se aplicó
    this.tempSelectedProducts = [...this.selectedProducts];
  }, 150);
}

// Detectar clics fuera del componente para cerrar el dropdown
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  if (this.showDropdown) {
    const productSearchContainer = this.elementRef.nativeElement.querySelector('.product-search-input');
    if (productSearchContainer) {
      const clickedInside = productSearchContainer.contains(event.target as Node);
      if (!clickedInside) {
        this.closeDropdown();
      }
    }
  }
}

// === MANEJO INTELIGENTE DE SELECCIÓN CON LÓGICA CONDICIONAL ===
onProductSelectionChange(productCode: string, isChecked: boolean) {
  try {
    if (isChecked) {
      // 🔒 LÓGICA CONDICIONAL: Solo permitir una selección a la vez
      if (this.isMercantilSeguros(productCode)) {
        // Si selecciona mercantil seguros, limpiar todo y solo permitir este
        this.tempSelectedProducts = [productCode];
        // Forzar tipo de reporte a "Reporte de Seguros" (21)
        this.type = '21';
        console.log('🔒 Mercantil Seguros seleccionado - Solo reporte de seguros disponible');
      } else {
        // Si selecciona créditos u otro, limpiar mercantil seguros si existe
        this.tempSelectedProducts = this.tempSelectedProducts.filter(code => !this.isMercantilSeguros(code));
        
        // Agregar el nuevo producto si no está
        if (!this.tempSelectedProducts.includes(productCode)) {
          this.tempSelectedProducts.push(productCode);
        }
        
        // Si el tipo actual es reporte de seguros (21), cambiarlo a uno válido
        if (this.type === '21') {
          this.type = '3'; // Cambiar a "Reporte de Cartera de Crédito"
          console.log('🔄 Cambiando de reporte de seguros a reporte de crédito');
        }
      }
    } else {
      // Remover producto de la lista temporal
      this.tempSelectedProducts = this.tempSelectedProducts.filter(code => code !== productCode);
    }

    // Asegurar que siempre haya al menos un producto seleccionado
    if (this.tempSelectedProducts.length === 0) {
      this.tempSelectedProducts = ['CREDIT'];
    }
    
    console.log('✅ Productos seleccionados:', this.tempSelectedProducts);
  } catch (error) {
    console.error('❌ ERROR en selección:', error);
  }
}

// === APLICACIÓN PROFESIONAL DE FILTROS ===
async applyFilters() {
  try {
    this.filterStates.isApplyingFilter = true;
    this.filterStates.isLoadingResults = true;
    this.filterStates.hasError = false;

    // Confirmar selección
    this.selectedProducts = [...this.tempSelectedProducts];

    // Actualizar el término de búsqueda
    this.updateSearchTermFromSelection();

    // Establecer tipo de reporte por defecto según el producto seleccionado
    this.setDefaultReportType();

    // Animación de cierre suave
    await this.closeDropdown();

    // Aquí no llamamos a ningún servicio como se solicitó
    console.log('✅ Filtros aplicados:', this.selectedProducts);

  } catch (error) {
    console.error('❌ ERROR al aplicar filtros:', error);
    this.filterStates.hasError = true;
    this.filterStates.errorMessage = 'Error al aplicar filtros';
  } finally {
    this.filterStates.isApplyingFilter = false;
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIONES DE UTILIDAD MEJORADAS ===
isProductSelected(productCode: string): boolean {
  return this.tempSelectedProducts.includes(productCode);
}

// 🔍 IDENTIFICAR PRODUCTOS MERCANTIL SEGUROS
isMercantilSeguros(productCode: string): boolean {
  // Identificar específicamente productos SEGUROS_MERCANTIL
  return productCode?.toUpperCase() === 'SEGUROS_MERCANTIL' || 
         this.getProductName(productCode)?.toUpperCase().includes('MERCANTIL');
}

// 🔍 IDENTIFICAR PRODUCTOS SEGUROS CARACAS
isCaracasSeguros(productCode: string): boolean {
  // Identificar específicamente productos SEGUROS_CARACAS
  return productCode?.toUpperCase() === 'SEGUROS_CARACAS' || 
         this.getProductName(productCode)?.toUpperCase().includes('CARACAS');
}

// 🔍 IDENTIFICAR CUALQUIER TIPO DE SEGUROS
isAnySeguros(productCode: string): boolean {
  return this.isMercantilSeguros(productCode) || this.isCaracasSeguros(productCode);
}

// 🏷️ OBTENER NOMBRE DEL PRODUCTO
getProductName(productCode: string): string {
  const product = this.productArray?.find(p => p?.params?.code === productCode);
  return product?.params?.name || productCode;
}

// 🚫 VERIFICAR SI REPORTE ESTÁ DISPONIBLE PARA PRODUCTO SELECCIONADO
isReportAvailableForSelectedProducts(reportType: string): boolean {
  const hasMercantilSeguros = this.selectedProducts.some(code => this.isMercantilSeguros(code));
  const hasCaracasSeguros = this.selectedProducts.some(code => this.isCaracasSeguros(code));
  const hasAnySeguros = this.selectedProducts.some(code => this.isAnySeguros(code));
  
  if (hasMercantilSeguros) {
    // Si tiene mercantil seguros, permitir ambos reportes de seguros (21 y 24)
    return reportType === '21' || reportType === '24';
  } else if (hasCaracasSeguros) {
    // Si tiene seguros caracas, solo permitir reporte de seguros básico (21)
    return reportType === '21';
  } else if (hasAnySeguros) {
    // Si tiene cualquier otro tipo de seguros, solo reporte básico (21)
    return reportType === '21';
  } else {
    // Si NO tiene seguros, permitir todos EXCEPTO reportes de seguros (21 y 24)
    return reportType !== '21' && reportType !== '24';
  }
}

// 🔍 VERIFICAR SI HAY PRODUCTOS MERCANTIL SEGUROS SELECCIONADOS
hasMercantilSegurosSelected(): boolean {
  return this.selectedProducts.some(code => this.isMercantilSeguros(code));
}

// 🔍 VERIFICAR SI HAY PRODUCTOS SEGUROS CARACAS SELECCIONADOS
hasCaracasSegurosSelected(): boolean {
  return this.selectedProducts.some(code => this.isCaracasSeguros(code));
}

// 🔍 VERIFICAR SI HAY CUALQUIER TIPO DE SEGUROS SELECCIONADOS
hasAnySegurosSelected(): boolean {
  return this.productType === 'INSURANCE';
}

// ✅ VERIFICAR SI HAY PRODUCTOS NO-SEGUROS SELECCIONADOS
hasNonSegurosSelected(): boolean {
  return this.productType === 'CREDIT';
}

// 🔄 MANEJAR CAMBIO DE TIPO DE PRODUCTO
onProductTypeChange(): void {
  console.log('📦 Tipo de producto cambiado a:', this.productType);
  // Resetear el tipo de reporte seleccionado
  this.type = '';
  // Reset del filtro de producto domiciliado al default por categoría
  this.domiciliation_product_type = this.productType === 'INSURANCE' ? 'SEGUROS_MERCANTIL' : 'CREDIT';
}

// 🔄 CAMBIO DE TIPO DE PRODUCTO DOMICILIADO: recarga listado para no mezclar reportes
onDomiciliationProductTypeChange(): void {
  if (String(this.type) === '7') {
    this.trace_documets = [];
    this.getTrace_documets('CLIENT_2', this.domiciliation_product_type);
  }
}

// 📝 OBTENER VALOR A MOSTRAR EN EL INPUT
getDisplayValue(): string {
  if (this.selectedProducts.length === 0) {
    return this.productSearchTerm || '';
  }
  
  if (this.showDropdown && this.productSearchTerm) {
    return this.productSearchTerm;
  }
  
  // Mostrar el código del primer producto seleccionado (en lugar del nombre)
  const firstProduct = this.selectedProducts[0];
  const productCode = firstProduct; // Mostrar el código directamente
  
  if (this.selectedProducts.length === 1) {
    return productCode;
  } else {
    return `${productCode} (+${this.selectedProducts.length - 1} más)`;
  }
}

// 🔍 MANEJAR INPUT DE BÚSQUEDA
onSearchInput(event: any): void {
  const value = event.target.value;
  this.productSearchTerm = value;
  this.filterProductsSearch();
  
  if (!this.showDropdown) {
    this.openDropdown();
  }
}

getSelectedProductsText(): string {
  const count = this.selectedProducts.length;

  if (count === 0) {
    return 'Seleccionar productos...';
  }
  if (count === 1) {
    return this.selectedProducts[0];
  }
  if (count === 2) {
    return `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  }
  return `${count} productos seleccionados`;
}

async clearAllFilters() {
  this.tempSelectedProducts = ['CREDIT'];
  this.selectedProducts = ['CREDIT'];

  try {
    this.filterStates.isLoadingResults = true;
    // Aquí no llamamos a ningún servicio como se solicitó
    console.log('✅ Filtros limpiados');
  } catch (error) {
    console.error('❌ ERROR al limpiar filtros:', error);
  } finally {
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIÓN DE RETRY PARA ERRORES ===
async retryOperation() {
  this.filterStates.hasError = false;
  this.filterStates.errorMessage = '';

  try {
    if (!this.filterStates.isInitialized) {
      await this.consultAllProductsInvoices();
    } else {
      await this.applyFilters();
    }
  } catch (error) {
    console.error('❌ ERROR en retry:', error);
    this.filterStates.hasError = false;
    this.filterStates.errorMessage = '';
  }
}

// === FUNCIONES DE OPTIMIZACIÓN ===
trackByProductCode(index: number, item: any): string {
  return item?.params?.code || index;
}

// 💎 BÚSQUEDA DE PRODUCTOS - Métodos
filterProductsSearch() {
  if (!this.productArray) {
    this.filteredProductArray = [];
    return;
  }

  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    this.filteredProductArray = [...this.productArray];
    return;
  }

  const term = this.productSearchTerm.toLowerCase().trim();
  this.filteredProductArray = this.productArray.filter((product: any) => {
    return (
      product?.params?.name?.toLowerCase().includes(term) ||
      product?.params?.code?.toLowerCase().includes(term) ||
      (product?.params?.dinamic_code && 
       product.params.dinamic_code.some((code: string) => code.toLowerCase().includes(term)))
    );
  });

  console.log('🔍 Productos filtrados:', this.filteredProductArray.length);
}

// Limpiar búsqueda de productos
clearProductSearch() {
  this.productSearchTerm = '';
  this.filteredProductArray = [...this.productArray];
}

// Actualizar el término de búsqueda con los productos seleccionados
updateSearchTermFromSelection() {
  if (this.selectedProducts.length === 0) {
    this.productSearchTerm = '';
  } else if (this.selectedProducts.length === 1) {
    // Un solo producto: mostrar su código
    this.productSearchTerm = this.selectedProducts[0];
  } else if (this.selectedProducts.length === 2) {
    // Dos productos: mostrar ambos códigos separados por "y"
    this.productSearchTerm = `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  } else {
    // Más de 2 productos: mostrar resumen
    this.productSearchTerm = `${this.selectedProducts.length} productos seleccionados`;
  }
  
  console.log('🔍 Término de búsqueda actualizado:', this.productSearchTerm);
}

// Establecer tipo de reporte por defecto según el producto seleccionado
setDefaultReportType() {
  if (this.selectedProducts.length === 1) {
    const selectedProduct = this.selectedProducts[0];
    
    if (this.isMercantilSeguros(selectedProduct)) {
      // Mercantil seguros: seleccionar reporte de pagos por defecto
      this.type = '24';
      console.log('🔒 Mercantil Seguros - Seleccionando reporte de pagos por defecto');
    } else if (this.isCaracasSeguros(selectedProduct)) {
      // Seguros Caracas: seleccionar reporte de seguros básico
      this.type = '21';
      console.log('🔒 Seguros Caracas - Seleccionando reporte de seguros por defecto');
    } else if (this.isAnySeguros(selectedProduct)) {
      // Otros seguros: seleccionar reporte de seguros básico
      this.type = '21';
      console.log('🔒 Otros Seguros - Seleccionando reporte de seguros por defecto');
    } else {
      // Otros productos: limpiar selección si estaba en seguros
      if (this.type === '21' || this.type === '24') {
        this.type = '';
        console.log('🔄 Producto no-seguros - Limpiando selección de reporte');
      }
    }
  } else {
    // Múltiples productos o ninguno: limpiar selección
    this.type = '';
    console.log('🔄 Múltiples productos - Limpiando selección de reporte');
  }
}

// 🗑️ LIMPIAR SELECCIÓN DE PRODUCTOS COMPLETAMENTE
clearProductSelection() {
  this.productSearchTerm = '';
  this.selectedProducts = ['CREDIT'];
  this.tempSelectedProducts = ['CREDIT'];
  this.filteredProductArray = [...this.productArray];
  this.closeDropdown();
  
  // Si estaba en reporte de seguros, cambiar a uno válido
  if (this.type === '21') {
    this.type = '3'; // Cambiar a reporte de crédito
    console.log('🔄 Limpiando selección - Cambiando a reporte de crédito');
  }
  
  console.log('🗑️ Selección de productos limpiada');
}

setCodeTypeProduct(event: any) {
  try {
    const selectedValue = event.target.value;

    // 🔒 APLICAR LÓGICA CONDICIONAL
    if (this.isMercantilSeguros(selectedValue)) {
      // Mercantil seguros: permitir ambos reportes de seguros
      this.selectedProducts = [selectedValue];
      this.tempSelectedProducts = [selectedValue];
      this.type = '24'; // Forzar reporte de PAGOS de seguros por defecto
      console.log('🔒 Mercantil Seguros - Seleccionando reporte de pagos por defecto');
    } else if (this.isCaracasSeguros(selectedValue)) {
      // Seguros Caracas: solo reporte de seguros básico
      this.selectedProducts = [selectedValue];
      this.tempSelectedProducts = [selectedValue];
      this.type = '21'; // Forzar reporte de seguros
      console.log('🔒 Seguros Caracas - Solo reporte de seguros básico');
    } else if (this.isAnySeguros(selectedValue)) {
      // Otros seguros: solo reporte de seguros básico
      this.selectedProducts = [selectedValue];
      this.tempSelectedProducts = [selectedValue];
      this.type = '21'; // Forzar reporte de seguros
      console.log('🔒 Otros Seguros - Solo reporte de seguros básico');
    } else {
      // Otros productos: permitir todos los reportes excepto seguros
      this.selectedProducts = [selectedValue];
      this.tempSelectedProducts = [selectedValue];
      
      // Si estaba en reporte de seguros, cambiar a uno válido
      if (this.type === '21' || this.type === '24') {
        this.type = '3'; // Cambiar a reporte de crédito
        console.log('🔄 Cambiando de seguros a reporte de crédito');
      }
    }
    
    this.typeProduct = selectedValue;
    console.log('✅ Producto seleccionado:', selectedValue, 'Tipo reporte:', this.type);
  } catch (error) {
    console.error(error);
  }
}

}
